export default {
  computed: {
    model () {
      return this.$parent?.model || this.$parent?.$parent?.model
    }
  }
}
